// extracted by mini-css-extract-plugin
export default {"wrapper":"login_wrapper__sX7aX","container":"login_container__MsfmJ","boxLogo":"login_boxLogo__7cEOm","boxInput":"login_boxInput__fIOW6"};